<template>
	<v-app id="inspire">
		<v-content>
			<v-container
				class="fill-height"
				fluid>
				<v-row
					align="center"
					justify="center">
					<v-col
						cols="12"
						sm="8"
						md="4">
						<v-card class="elevation-12">
							<v-toolbar
								color="#97257b"
								dark
								flat>
								<v-toolbar-title>Login form</v-toolbar-title>
								<v-spacer />
							</v-toolbar>
							<v-card-text>
								<v-form>
									<v-text-field
										label="Email"
										name="login"
										v-model="email"
										prepend-icon="mdi-account"
										type="text"/>

									<v-text-field
										id="password"
										v-model="password"
										label="Password"
										name="password"
										prepend-icon="mdi-lock"
										type="password"/>
								</v-form>
							</v-card-text>

							<v-card-actions>
								<v-spacer />
								<v-btn color="#ccc"
								       @click="loginUser">
									Login
								</v-btn>
							</v-card-actions>

						</v-card>
					</v-col>
				</v-row>
			</v-container>
		</v-content>
	</v-app>
</template>

<script>
	import {db} from "../../db";

	export default {
		data(){
			return{
				email: '',
				password: ''
			}
		},
		methods:{
			loginUser(){
				db.auth().createUserWithEmailAndPassword(this.email, this.password)
					.catch(function(error) {
						console.log('error', error)
				});
			}
		}
	}
</script>
